import { GET_GAME_DETAIL, GET_GAME_DETAIL_FAILURE, GET_GAME_DETAIL_SUCCESS, GETFILTERGAMES_SUCCESS, SET_GAME_NAME } from "../constants";

export default class GamesDetailActions {
    static GetGameDetail() {
        return {
            type: GET_GAME_DETAIL,
        };
    }
    static GetGameDetailSuccess() {
        return {
            type: GET_GAME_DETAIL_SUCCESS,
        };
    }
    static GetGameDetailFailure() {
        return {
            type: GET_GAME_DETAIL_FAILURE,
        };
    }
    static SetGameName(payload) { 
        return {
            type: SET_GAME_NAME,
            payload
        }
    }
}